import * as yup from 'yup';

export const formSchema = yup.object().shape({
  name: yup.string().trim().required(),
});
